import { render, staticRenderFns } from "./CityHealDialog.vue?vue&type=template&id=99efedfe&scoped=true"
import script from "./CityHealDialog.vue?vue&type=script&lang=js"
export * from "./CityHealDialog.vue?vue&type=script&lang=js"
import style0 from "./CityHealDialog.vue?vue&type=style&index=0&id=99efedfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99efedfe",
  null
  
)

export default component.exports